
import axios from '../config/axios';

export const url = '/api/menuitems'


export const getAllmenuitems = ({
  token,
}) => new Promise((resolve, reject) => {
  if (token) {
    axios.get(`${url}//list/basic/68abd8cd60a29c1eab0fc416`, {
      headers: {
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch((error) => reject(error));
  } else {
    reject({
      status: 'error',
      info: 'Token no definido',
    });
  }
});
      
export const customgetmenu_68fb95efe307249250068e11 = ({
  categorymenu,

}) => new Promise((resolve, reject) => {
  if (categorymenu) {
    axios.get(`${url}/custom/getmenu`, {
      params: {
        categorymenu,

      },
      
    }).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



